module.exports = __webpack_public_path__ + "img/202208.6dc7d875.png";